import React from 'react';
import classNames from 'classnames';
import { mapDegreesCardinal } from '@surfline/web-common';
import { TideArrowIcon } from '@wavetrak/theme';

import SurfHeight from 'components/SurfHeight';
import type { ForecastTide, ForecastWind } from 'types/spot';
import type { Units } from 'types/units';
import getUnitType from 'utils/getUnitType';

import styles from './SpotReportSummary.module.scss';

interface WaveHeight {
  min: number;
  max: number;
  plus: boolean;
}

interface SpotReportSummaryProps {
  units: Units;
  waveHeight: WaveHeight;
  tide?: ForecastTide;
  wind: ForecastWind;
}

const summaryClass = (tide?: ForecastTide) =>
  classNames({
    [styles.spotReportSummary]: true,
    'quiver-spot-report-summary': true,
    'quiver-spot-report-summary--no-tide': !tide,
  });

const SpotReportSummary: React.FC<SpotReportSummaryProps> = ({ waveHeight, tide, wind, units }) => (
  <div className={summaryClass(tide)}>
    <div className="quiver-spot-report-summary__stat">
      <div className="quiver-spot-report-summary__label">
        SURF ({getUnitType(units.waveHeight)})
      </div>
      <div className="quiver-spot-report-summary__value">
        <SurfHeight
          min={waveHeight.min}
          max={waveHeight.max}
          plus={waveHeight.plus}
          units={units.waveHeight}
        />
      </div>
    </div>
    {tide && tide.current && tide.next ? (
      <div className="quiver-spot-report-summary__stat">
        <div className="quiver-spot-report-summary__label">TIDE ({units.tideHeight})</div>
        <div className="quiver-spot-report-summary__value">
          {tide.current.height}
          <TideArrowIcon
            className="quiver-tide-arrow"
            direction={tide.next.type === 'LOW' ? 'falling' : 'rising'}
          />
        </div>
      </div>
    ) : null}
    <div className="quiver-spot-report-summary__stat">
      <div className="quiver-spot-report-summary__label">WIND ({units.windSpeed})</div>
      <div className="quiver-spot-report-summary__value">
        {wind.speed} {mapDegreesCardinal(wind.direction)}
      </div>
    </div>
  </div>
);

export default SpotReportSummary;
